/* wtf-star-links.js  (R26, 2026-11-01)
 * Makes the star rating and the review count on a product card a real link to /pages/reviews.
 * Why a script: snippets/card-product.liquid is over the 34,000 character push ceiling, so it cannot be rebuilt whole.
 * It swaps div.rating for a.rating (same classes, same children) and wraps the "(N)" count in an a.
 * It changes no number, no rating value, and no rating markup values. It never blocks anything: any failure leaves the card as it was. */
(function () {
  if (window.__wtfStarLinks) return;
  window.__wtfStarLinks = true;
  var HREF = '/pages/reviews';
  var NAME = 'Read our customer reviews';
  var css = '.card-information > a.rating, .card-information .rating-count > a { position: relative; z-index: 2; color: inherit; text-decoration: none; }' +
    '.card-information > a.rating::after, .card-information .rating-count > a::after { content: ""; position: absolute; left: -8px; right: -8px; top: 50%; height: 44px; transform: translateY(-50%); }' +
    '.card-information > a.rating:focus-visible, .card-information .rating-count > a:focus-visible { outline: 2px solid #35C0E0; outline-offset: 2px; border-radius: 3px; }' +
    '.card-information .rating-count > a:hover { text-decoration: underline; }' +
    '.card-wrapper .rating-star { --color-rating-star: #35C0E0; }';
  var st = document.createElement('style');
  st.setAttribute('data-wtf-star-links', '');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);
  function upgrade(root) {
    try {
      var stars = root.querySelectorAll('.card-wrapper .card-information > div.rating');
      for (var i = 0; i < stars.length; i++) {
        var old = stars[i];
        var a = document.createElement('a');
        a.className = old.className;
        a.href = HREF;
        var lab = old.getAttribute('aria-label');
        a.setAttribute('aria-label', (lab ? lab + '. ' : '') + NAME);
        while (old.firstChild) a.appendChild(old.firstChild);
        old.parentNode.replaceChild(a, old);
      }
      var counts = root.querySelectorAll('.card-wrapper .card-information > p.rating-count');
      for (var j = 0; j < counts.length; j++) {
        var p = counts[j];
        if (p.querySelector('a')) continue;
        var hid = p.querySelector('.visually-hidden');
        var l2 = (hid ? hid.textContent.replace(/\s+/g, ' ').trim() + '. ' : '') + NAME;
        var b = document.createElement('a');
        b.href = HREF;
        b.setAttribute('aria-label', l2);
        while (p.firstChild) b.appendChild(p.firstChild);
        p.appendChild(b);
      }
    } catch (e) { /* leave the card as it was */ }
  }
  var queued = false;
  function later() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; upgrade(document); });
  }
  upgrade(document);
  if ('MutationObserver' in window) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
})();
